import { Dropdown } from "primereact/dropdown";
import { isSovViewId, SOV_VIEWS, SovView, SovViewId } from "./sovViews";
import styles from "./SovViewSwitcher.module.css";

type SovViewSwitcherProps = {
  viewId: SovViewId;
  onChange: (viewId: SovViewId) => void;
};

/** Picker over the SOV views in sovViews.ts; one is always selected. */
export const SovViewSwitcher = ({ viewId, onChange }: SovViewSwitcherProps) => (
  <Dropdown
    value={viewId}
    options={SOV_VIEWS.map((view) => ({ ...view, value: view.id }))}
    optionLabel="label"
    optionValue="value"
    onChange={(e) => {
      if (isSovViewId(e.value)) onChange(e.value);
    }}
    valueTemplate={(view: SovView | null) => (
      <span className={styles.value}>
        <i className="pi pi-table" />
        {view?.label}
      </span>
    )}
    itemTemplate={(view: SovView) => (
      <div className={styles.item}>
        <span>{view.label}</span>
        <small className={styles.description}>{view.description}</small>
      </div>
    )}
    className={styles.dropdown}
    tooltip="Column view"
    tooltipOptions={{ showDelay: 500 }}
  />
);
